export default "__VITE_ASSET__BOPewc5Y__"